import _ from 'underscore';

export type FlexibleGridLineNumber = number;
export type FlexibleGridContainerName = string;

export const flexibleGrid = () => ({
  display: 'grid',
  fallbacks: [
    {
      display: '-ms-grid',
    },
  ],
});

const flexibleGridItem = () => ({
  justifySelf: 'stretch',
  '-ms-grid-column-align': 'stretch',
});

export const flexibleGridRow = (number: FlexibleGridLineNumber) => ({
  extend: flexibleGridItem(),
  '-ms-grid-row': `${number}`,
  gridRowStart: `${number}`,
});

export const flexibleGridRowSpan = (number: FlexibleGridLineNumber) => ({
  '-ms-grid-row-span': `${number}`,
  gridRowEnd: `span ${number}`,
});

export const flexibleGridRows = (
  isGlobal: boolean,
  containerName: FlexibleGridContainerName,
  number: FlexibleGridLineNumber
) =>
  _.chain(_.range(1, number + 1))
    .map(index => ({
      [isGlobal ?
        `.${containerName}__flexible-grid-row-${index}` :
        `${containerName}FlexibleGridRow${index}`]: flexibleGridRow(index),
      [isGlobal ?
        `.${containerName}__flexible-grid-row-span-${index}` :
        `${containerName}FlexibleGridRowSpan${index}`]: flexibleGridRowSpan(index),
    }))
    .reduce((m, o) => ({ ...m, ...o }))
    .value();

export const flexibleGridColumn = (number: FlexibleGridLineNumber) => ({
  extend: flexibleGridItem(),
  '-ms-grid-column': `${number}`,
  gridColumnStart: `${number}`,
});

export const flexibleGridColumnSpan = (number: FlexibleGridLineNumber) => ({
  '-ms-grid-column-span': `${number}`,
  gridColumnEnd: `span ${number}`,
});
